import React from "react";
import EditableInput from "./EditableInput";
import { buildCompactPreview } from "../../../utils/editableRecord";

const LargeObjectEditor = ({
  entry,
  objectFields,
  selectedIndex,
  onSelectIndex,
  onAddField,
  onRemoveField,
  selectedField,
  onChangeField,
}) => (
  <div className="space-y-3 rounded-2xl border border-slate-800/90 bg-slate-950/40 p-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-[12rem] flex-1">
        <p className="text-xs text-slate-400">Edit one field at a time.</p>
        <select
          value={selectedIndex >= 0 ? String(selectedIndex) : ""}
          onChange={(event) => onSelectIndex(Number(event.target.value))}
          disabled={!objectFields.length}
          aria-label={`${entry.label} selected field`}
          className="mt-2 min-h-[3rem] w-full rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {objectFields.map((field, index) => (
            <option key={`${entry.key}-field-option-${index}`} value={index}>
              {`Field ${index + 1} - ${buildCompactPreview(field?.keyName || "Untitled")} - ${buildCompactPreview(field?.textValue ?? field?.templateValue)}`}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onAddField}
          className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
          aria-label={`Add ${entry.label} field`}
        >
          Add field
        </button>
        <button
          type="button"
          onClick={() => onRemoveField(selectedIndex)}
          disabled={selectedIndex < 0}
          className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
          aria-label={`Remove ${entry.label} field`}
        >
          Remove field
        </button>
      </div>
    </div>

    {selectedField ? (
      <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3">
        <div className="mb-3 flex items-center justify-between gap-3">
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
            Field {selectedIndex + 1}
          </span>
          <span className="text-xs text-slate-400">
            {selectedField.mode === "json" ? "JSON value" : "Text value"}
          </span>
        </div>
        <div className="space-y-3">
          <EditableInput
            value={selectedField.keyName ?? ""}
            onChange={(event) => onChangeField(selectedIndex, "keyName", event.target.value)}
            ariaLabel={`${entry.label} selected field key`}
            placeholder="Field name"
          />
          <EditableInput
            value={selectedField.textValue ?? ""}
            onChange={(event) => onChangeField(selectedIndex, "textValue", event.target.value)}
            multiline
            rows={selectedField.mode === "json" ? 8 : 6}
            ariaLabel={`${entry.label} selected field value`}
            placeholder={selectedField.mode === "json" ? "Enter valid JSON for this value" : "Field value"}
          />
        </div>
      </div>
    ) : (
      <div className="rounded-2xl border border-dashed border-slate-700 px-4 py-4 text-sm text-slate-400">
        No fields yet. Add one to start editing this object.
      </div>
    )}
  </div>
);

export default LargeObjectEditor;
